// @ts-nocheck
import CategoryObject from "classes/Categories/CategoryObject";
import DocumentObject from "classes/Documents/DocumentObject";
import documents_treat from "includes/documents_treat";
import formatDate from "includes/formatDate";
import noAccent from "includes/no_accents";
import { FILES_URL } from "includes/paths";
import genRequest from "includes/request";

export default function PostObject(post) {
	let INIT_DATE = formatDate();
	let that = this;

	let postId;
	let postTypeId;
	let subTitle;
	let title;
	let employeeId;
	let txt;
	let siteId;
	let validationModeration;
	let draft;
	let address;
	let viewCount;
	let likesCount;
	let publishedDate = INIT_DATE;
	let priorityTo = INIT_DATE;
	let moderationComment;
	let lastChanged;
	let lastChangeAuthorId;
	let hasDuplicate;
	let isTargetPost;
	let languageId;
	let pendingImages = [];

	let isRejected = false;
	// Existing posts carry their author (joined by the API); a new post is
	// built from the editor's account.
	let author = post?.author ?? post?.account;
	// The editor (v1 `Account` at construction): the unlink rights depend on
	// who edits, not on who wrote the post.
	const account = post?.account;
	let notifyPost =
		typeof post?.notifyPost !== "undefined" ? post.notifyPost : true;
	let companyId = post?.companyId !== undefined ? post.companyId : null;
	let rssImages = [];
	let images = [];
	let videos = [];
	let MDE_Ref = false;
	let linkType = "sites";
	let linkTo = [];
	let linkedTo = [];
	let categories = [];
	let linkedSites = [];
	let linkedGroups = [];
	let linkedForms = [];
	let targets = [];

	let reactionType = false;
	let response = false;

	let docs = [];

	this.setProps = function (props, force_notif) {

		postId = props && props.id !== undefined ? props.id : undefined;
		postTypeId =
			props && props.postTypeId !== undefined ? props.postTypeId : null;

		if (postTypeId === 3 && props.title) {
			let split = props.title.split(/\/__CUT__\\/gi);
			subTitle = split[0];
			title = split[1];
		} else title = props?.title !== undefined ? props.title : "";
		employeeId = props?.employeeId !== undefined ? props.employeeId : null;
		txt = props?.txt !== undefined ? props.txt : "";
		siteId = props?.siteId !== undefined ? props.siteId : null;
		validationModeration =
			props?.validationModeration !== undefined
				? props.validationModeration
				: false;
		draft = props?.draft !== undefined ? props.draft : false;
		address = props?.address !== undefined ? props.address : "DesktopV2";
		viewCount = props?.viewCount !== undefined ? props.viewCount : 0;
		likesCount = props?.likesCount !== undefined ? props.likesCount : 0;
		publishedDate =
			props?.publishedDate !== undefined
				? props.publishedDate
				: formatDate();
		priorityTo = props?.priorityTo !== undefined ? props.priorityTo : null;
		moderationComment =
			props?.moderationComment !== undefined
				? props.moderationComment
				: null;
		lastChanged =
			props?.lastChanged !== undefined ? props.lastChanged : null;
		lastChangeAuthorId =
			props?.lastChangeAuthorId !== undefined
				? props.lastChangeAuthorId
				: null;
		hasDuplicate =
			props?.hasDuplicate !== undefined ? props.hasDuplicate : false;
		isTargetPost =
			props?.isTargetPost !== undefined ? props.isTargetPost : false;
		languageId = props?.languageId !== undefined ? props.languageId : 1;

		isRejected = props?.isRejected !== undefined ? props.isRejected : false;

		reactionType =
			props?.reactionType !== undefined
				? props.reactionType
				: reactionType;

		if (typeof force_notif !== "undefined") notifyPost = force_notif;
		else {
			if (props?.notifyPost) notifyPost = true;
			else notifyPost = postId ? false : true;
		}
	};

	this.pendingImages = function (setPendingImages) {
		if (typeof setPendingImages !== "undefined") pendingImages = setPendingImages;
		return pendingImages;
	};

	this.cleanMarkdownForFirstSave = function () {
		if (!pendingImages?.length) return txt;

		let cleanedTxt = txt;
		pendingImages.forEach((img) => {
			cleanedTxt = cleanedTxt.replace(
				img.originalMatch,
				`![Image en cours de traitement...](placeholder_${img.newIndex})`
			);
		});

		return cleanedTxt;
	};

	this.processMarkdownImages = async function () {
		if (!pendingImages?.length || pendingImages.length === 0) return Promise.resolve();

		try {
			const uploadPromises = pendingImages.map((img, index) =>
				that.sendImage(img, index)
			);

			await Promise.all(uploadPromises);

			const postDocuments = await genRequest("documents/post/" + postId);

			const imageDocuments = postDocuments
				.filter(doc => doc.documentTypeId === 3)
				.sort((a, b) => a.name.localeCompare(b.name));

			let processedTxt = txt;
			pendingImages.forEach((img, index) => {
				if (imageDocuments[index]) {
					const imageUrl = imageDocuments[index].urlWeb;
					processedTxt = processedTxt.replace(
						img.originalMatch,
						`![](${FILES_URL}${imageUrl})`
					);
				}
			});

			txt = processedTxt;
			pendingImages = [];

			return Promise.resolve();
		} catch (error) {
			throw error;
		}
	};

	this.setProps(post);

	this.fetchForEdit = (asClone) => {
		if (!postId) return Promise.resolve(true);
		return Promise.allSettled([
			this.fetchLinkedGroups(),
			this.fetchLinkedSites(),
			this.fetchResponse(),
			this.fetchImages().then(() => that.fetchImagesFile(asClone)),
			this.fetchVideos(),
			this.fetchCategories(),
			this.fetchLinkedDocs(asClone),
			this.fetchLinkedForms(),
			this.fetchTargets(),
			this.fetchReactionType(),
		]);
	};

	this.fetchForDuplicate = () => {
		let prom = this.fetchForEdit(true).then(() => {
			postId = false;
			if (response) this.setResponse("", null, true);
		});
		return prom;
	};

	this.fetchAuthor = () => {
		if (!employeeId) return Promise.reject(false);
		let req = genRequest("employees/" + employeeId).then((resp) => {
			author = resp;
			return resp;
		});
		return req;
	};

	this.fetchTargets = () => {
		if (postTypeId !== 13) return Promise.resolve([]);
		let req = genRequest("posts/" + postId + "/alerts").then(
			(resp) => {
				if (resp.length) targets = resp;
				else targets = [];
			},
			() => {
				targets = [];
			}
		);
		return req;
	};

	this.fetchLinkedSites = () =>
		genRequest("posts/" + postId + "/sites").then(
			(resp) => {
				linkedSites = resp?.length ? resp : [];
				if (resp?.length) linkType = "sites";
			},
			() => {
				linkedSites = [];
			}
		);

	this.fetchResponse = () =>
		genRequest("posts/" + postId + "/responses")
			.then((resp) => {
				// API returns Post[] — must take resp[0]. Passing the array
				// to PostObject yielded an object with all fields undefined,
				// so the complement editor opened empty AND each autoSave
				// inserted a NEW response post (the original existed but
				// looked unsaved), eventually multiplying response rows.
				const first = Array.isArray(resp) ? resp[0] : resp;
				response = first ? new PostObject(first) : false;
			})
			.catch(() => (response = false));

	this.fetchLinkedGroups = () =>
		genRequest("groups/post/" + postId).then(
			(resp) => {
				linkedGroups = resp?.length ? resp : [];
				if (resp?.length) linkType = "groups";
				return resp;
			},
			() => {
				linkedGroups = [];
				return [];
			}
		);

	this.fetchLinkedDocs = (asClone) =>
		genRequest("documents/post/" + postId + "/type/4")
			.then((resp) => {
				if (!resp?.length) {
					docs = [];
					return docs;
				}
				docs = resp.map((a) => {
					let doc = { ...a };
					if (asClone) {
						doc.originalDocumentId = false;
						doc.documentId = false;
						doc.isNew = true;
						doc.isCloned = true;
						doc.documentId = false;
					}
					return new DocumentObject(doc);
				});
				return docs;
			})
			.catch(() => {
				return [];
			});

	this.fetchLinkedForms = () =>
		genRequest("posts/" + postId + "/form-affectations")
			.then((resp) => {
				linkedForms = resp?.length ? resp : [];
			})
			.catch(() => {
				linkedForms = [];
			});

	this.fetchImages = () =>
		genRequest("documents/post/" + postId + "/type/3")
			.then((resp) => {
				images = documents_treat(resp, "name").map((a) => {
					a.originalDocumentId = a.documentId;
					return a;
				});
				return images;
			})
			.catch(() => {
				return [];
			});

	this.fetchVideos = () =>
		genRequest("documents/post/" + postId + "/type/15")
			.then((resp) => {
				videos = documents_treat(resp, "name");
				return videos;
			})
			.catch(() => {
				videos = [];
				return [];
			});

	this.fetchImagesFile = (cloned) => {
		if (!images?.length) return Promise.resolve(true);
		let proms = images.map((a) => {
			return fetchDocumentFile(a.documentId).then((resp) => {
				a.documentFile = resp;
				if (cloned) {
					a.originalDocumentId = false;
					a.documentId = false;
					a.isNew = true;
					a.isCloned = true;
				}
			});
		});
		return Promise.all(proms);
	};

	const fetchDocumentFile = (documentId) =>
		genRequest("documents/" + documentId + "/file").then(
			(documentFile) => {
				return documentFile;
			}
		);

	this.fetchDefaultReactionType = () =>
		genRequest(
			`reaction-types/default/${postTypeId}/${companyId}`
		).then((resp) => {
			reactionType = resp?.length
				? { reactionTypeId: resp[0].reactionTypeId }
				: false;
			return resp;
		});

	this.fetchReactionType = () => {
		let req = genRequest("posts/" + postId + "/reactions").then(
			(resp) => {
				if (!resp?.length) return this.fetchDefaultReactionType();
				reactionType = resp?.length ? resp[0] : false;
				return resp;
			},
			() => {
				return this.fetchDefaultReactionType();
			}
		);
		return req;
	};

	this.unlinkReactionType = () =>
		genRequest("posts/" + postId + "/available-reactions", null, "delete");

	this.linkReactionType = () => {
		if (!reactionType?.reactionTypeId) return Promise.resolve(true);
		let req = genRequest(
			`posts/${postId}/available-reactions`,
			{
				reactionTypeId: reactionType.reactionTypeId,
			},
			"post"
		);
		return req;
	};

	this.send = function () {
		let prom = new Promise((resolve, reject) => {
			let originalTxt = txt;
			let hasImages = pendingImages && pendingImages.length > 0;

			if (hasImages) {
				txt = that.cleanMarkdownForFirstSave();
			}
			let xhr = that
				.sendPost()
				.then(() => {
					if (!hasImages) {
						return Promise.resolve();
					}
					txt = originalTxt;
					return that.processMarkdownImages();
				}, reject)
				.then(() => {
					if (hasImages) {
						return that.sendPost(); //PUT to update image in the markdown
					}
					return Promise.resolve();
				}, reject)
				.then(() => {
					let proms = [
						that.unlinkSites(),
						that.unlinkGroups(),
						that.unlinkCategories(),
						that.unlinkForms(),
						that.unlinkDocs(),
						that.unlinkResponse(),
						//that.unlinkReactionType(),
					];
					return Promise.allSettled(proms);
				}, reject)
				.then(() => {
					if (linkType === "sites") return that.duplicateOnSites();
					return that.duplicateOnGroups();
				}, reject)
				.then(() => {
					return that.linkCategories();
				}, reject)
				.then(() => {
					return that.linkReactionType();
				}, reject)
				.then(() => {
					return that.sendReponse();
				}, reject)
				.then(() => {
					resolve(true);
				}, reject);
			return xhr;
		});
		return prom;
	};

	this.autoSave = function () {
		return that
			.send()
			.then(() => {
				let proms = [that.sendImages(), that.sendVideos(), that.sendDocs()];
				return Promise.allSettled(proms);
			})
			.then(() => {
				return that;
			});
	};

	this.sendPost = function () {
		let post = {
			postId: postId,
			postTypeId: postTypeId,
			title: postTypeId === 3 ? subTitle + "/__cut__\\" + title : title,
			employeeId: employeeId,
			txt: txt,
			siteId: siteId,
			validationModeration: validationModeration,
			draft: draft,
			address: address,
			viewCount: viewCount,
			likesCount: likesCount,
			publishedDate: publishedDate,
			priorityTo: priorityTo,
			moderationComment: moderationComment,
			lastChanged: formatDate(),
			lastChangeAuthorId: lastChangeAuthorId,
			hasDuplicate: linkTo?.length ? true : false,
			languageId: languageId,
			isTargetPost:
				linkType === "groups" && linkTo?.length ? true : isTargetPost,
		};
		if (!postId) delete post.postId;
		let prom = genRequest(
			"posts" + (postId ? "/" + postId : ""),
			post,
			postId ? "put" : "post"
		).then((resp) => {
			if (!postId) {
				let notify = notifyPost && validationModeration && !draft;
				that.setProps(resp, notify);
			}
		});
		return prom;
	};

	this.rejectPost = function (reason) {
		if (!reason?.length)
			return Promise.reject("Reject reason is requiered");
		this.moderationComment(reason);
		let prom = this.sendPost().then(() => this.notify());
		return prom;
	};

	this.unlinkSites = () =>
		genRequest("posts/" + postId + "/sites", null, "delete");

	this.duplicateOnSites = function () {
		if (!linkTo?.length) return true;
		let prom = genRequest(
			"posts/" + postId + "/duplicate-to-sites",
			{
				siteIds: linkTo,
			},
			"post"
		);
		return prom;
	};

	this.unlinkGroups = function () {
		if (account?.role === "UserPublisher") return Promise.resolve(true);
		let req = genRequest(
			"posts/" + postId + "/target-groups",
			null,
			"delete"
		);
		return req;
	};

	this.duplicateOnGroups = function () {
		if (!linkTo?.length) return Promise.resolve(true);
		let prom = genRequest(
			"posts/" + postId + "/target-groups",
			{
				groupIds: linkTo,
				notify: notifyPost,
			},
			"post"
		);
		return prom;
	};

	this.fetchCategories = () =>
		genRequest("categories/post/" + postId).then((resp) => {
			// API returns junction rows: [{postId, categoryId, category:{id,categoryName,...}}]
			// Flatten to {categoryId, categoryName, categoryColor, name} so every
			// downstream consumer (PostContentStep initialValue, EditPostPreview
			// tags, etc.) can read flat fields without needing to know the
			// junction shape.
			categories = !resp?.length
				? []
				: resp.map((row) => {
					const cat = row.category || {};
					return {
						categoryId: row.categoryId ?? cat.id,
						categoryName: cat.categoryName,
						categoryColor: cat.categoryColor,
						description: cat.description,
						name: cat.categoryName,
						label: cat.categoryName,
						value: row.categoryId ?? cat.id,
					};
				});
			return categories;
		});

	this.unlinkCategories = () =>
		genRequest("posts/" + postId + "/categories", null, "delete");

	this.linkCategories = function () {
		let proms = [];
		if (categories?.length)
			proms = categories.map((a) => {
				if (a.categoryId) return this.linkCategory(a.categoryId);
				return this.addCategory(a).then((resp) =>
					this.linkCategory(resp.categoryId)
				);
			});
		return Promise.all(proms);
	};

	this.addCategory = function (cat) {
		let obj = new CategoryObject({
			name: cat.name,
			categoryType: "post-" + postTypeId,
			description: "",
			companyId: companyId,
		});
		return obj.send();
	};

	this.linkCategory = (catId) =>
		genRequest(
			"posts/" + postId + "/categories",
			{
				categoryId: catId,
			},
			"post"
		);

	this.attachements = () => [...docs, ...linkedForms];

	this.linkAttachements = function () {
		let to_link = this.attachements();

		if (!to_link?.length) return Promise.resolve(true);
		let proms = [this.sendDocs(), this.linkForms()];
		return Promise.all(proms);
	};

	this.unlinkForms = () => {
		if (account?.role === "UserPublisher") return Promise.resolve(true);
		return genRequest(
			"posts/" + postId + "/form-affectations",
			null,
			"delete"
		);
	}

	this.linkForms = function () {
		if (!linkedForms?.length) return Promise.resolve(true);
		let proms = linkedForms.map((a) => this.linkForm(a.id));
		return Promise.all(proms);
	};

	this.linkForm = (formId) =>
		genRequest(
			"posts/" + postId + "/form-affectations",
			{
				formId: formId,
			},
			"post"
		);

	this.sendDocs = function () {
		if (!docs?.length) return Promise.resolve(true);
		let postLinks = this.getLinksTo();
		let links = docs.map((a) => {
			a.postId(postId);
			if (siteId) a.siteId(siteId);
			if (a.isNew()) {
				if (a.addToDocsUtiles())
					a.setLinkTo(postLinks.links, postLinks.type);
				else a.setLinkTo([], postLinks.type);
				a.documentId(null);
				a.urls(null);
				return a.send();
			}
			return a.linkDoc();
		});
		return Promise.all(links);
	};

	this.unlinkDocs = function () {
		if (!postId) return Promise.resolve(true);
		let prom = genRequest(
			// attachments only (type 4): images and videos relink on their own
			"posts/" + postId + "/documents?typeId=4",
			null,
			"delete"
		)
			.catch(() => Promise.resolve(true))
			.then(() => Promise.resolve(true));
		return prom;
	};

	this.sendImageRss = () => {
		let datas = {
			imageSourceUrl: rssImages[0],
			name: "RssImage-" + postId,
			postId: postId,
			companyId: companyId,
			siteId: siteId,
			docTypeId: 3,
		};

		let prom = genRequest(
			"documents/from-url",
			datas,
			"post"
		).then((documentId) => {
			return that.linkImage(documentId);
		});
		return prom;
	};

	this.sendImages = function () {
		let proms = images.map((img, index) => {
			if (
				!img.isDeleted &&
				(img.hasChanged || img.newIndex !== undefined || img.isNew)
			) {
				if (
					img.originalDocumentId &&
					!img.fromGallery &&
					!img.isCloned
				) {
					return that.deleteImage(img.originalDocumentId).then(() => {
						return that.sendImage(img, index);
					});
				}
				return that.sendImage(img, index);
			} else if (
				img.isDeleted &&
				!img.isNew &&
				img.originalDocumentId &&
				!img.fromGallery
			)
				return that.deleteImage(img.originalDocumentId);
			else if (img.originalDocumentId && !img.isDeleted)
				return that.putImage(img, index);
			return false;
		});
		if (rssImages.length > 0) proms.push(that.sendImageRss());
		return Promise.all(proms);
	};

	this.putImage = function (img, index) {
		let img_index = img.newIndex !== undefined ? img.newIndex : index;
		let imgTitle = noAccent(title).replace(/[\W]{1,}/gi, "_");
		let date = formatDate();
		let datas = {
			name: "pos:" + img_index + "_" + imgTitle + "_" + date,
			postId: postId,
			companyId: companyId,
			siteId: siteId,
			docTypeId: 3,
			documentTypeId: 3,
			lastChanged: date,
			urlMin: null,
			urlMobile: null,
			urlOrigin: null,
			urlWeb: null,
		};

		let prom = genRequest("documents/" + img.documentId, datas, "put").then(
			() => {
				return that.linkImage(img.documentId);
			}
		);
		return prom;
	};

	this.sendImage = function (img, index) {
		let file = img.documentFile;

		index = img.newIndex !== undefined ? img.newIndex : index;
		if (file && file.indexOf("data:image") !== -1) file = file.split(",")[1];
		let imgTitle = noAccent(title).replace(/[\W]{1,}/gi, "_");
		let date = formatDate();
		let datas = {
			name: "pos:" + index + "_" + imgTitle + "_" + date,
			postId: postId,
			companyId: companyId,
			siteId: siteId,
			fileDocString: file,
			docTypeId: 3,
		};

		let prom = genRequest(
			"documents/from-base64",
			datas,
			"post"
		).then((documentId) => {
			return that.linkImage(documentId);
		});
		return prom;
	};

	this.deleteImage = (docId) =>
		genRequest(
			"documents/" + docId,
			null,
			"delete"
		).catch(() => { });

	this.linkImage = (documentId) =>
		genRequest(
			"posts/" + postId + "/documents",
			{
				documentId: documentId,
			},
			"post"
		);

	this.sendVideos = function () {
		let proms = videos.map((video) => {
			if (video.isNew && !video.isDeleted) {
				return that.sendVideo(video);
			} else if (video.isDeleted && video.documentId) {
				return that.deleteVideo(video.documentId);
			} else if (!video.isDeleted && video.documentId) {
				return that.relinkVideo(video.documentId);
			}
			return null;
		}).filter(Boolean);
		return Promise.all(proms);
	};

	this.sendVideo = function (video) {
		let vidTitle = noAccent(title).replace(/[\W]{1,}/gi, "_");
		let date = formatDate();
		let formData = new FormData();
		formData.append("file", video.file);
		formData.append("name", "vid_" + vidTitle + "_" + date);
		formData.append("postId", postId);
		formData.append("companyId", companyId);
		formData.append("siteId", siteId);
		formData.append("docTypeId", 15);

		return genRequest(
			"documents",
			formData,
			"post",
			{ headers: { "Content-Type": undefined }, timeout: 300000 }
		);
	};

	this.relinkVideo = (docId) =>
		genRequest(
			"posts/" + postId + "/documents",
			{ documentId: docId },
			"post"
		).catch(() => { });

	this.deleteVideo = (docId) =>
		genRequest(
			"documents/" + docId,
			null,
			"delete"
		).catch(() => { });

	this.setAsPublished = function () {
		validationModeration = true;
		draft = false;
		moderationComment = "";
	};

	this.setAsDraft = function () {
		validationModeration = false;
		draft = true;
		moderationComment = "";
	};

	this.setAsToModerate = function () {
		validationModeration = false;
		draft = false;
		moderationComment = "";
	};

	this.setAsToModify = function (reason) {
		validationModeration = false;
		draft = false;
		moderationComment = reason;
	};

	this.notify = function (url_overload, data_overload) {
		if (
			!url_overload &&
			!isRejected &&
			(!notifyPost || linkType === "groups" || postTypeId === 8)
		)
			// don't notify if Animation (events) Post
			return Promise.resolve(true);

		let type = "News";
		let url;
		let data = {
			message: title,
			author: author,
			newsId: postId
		};

		if (url_overload) url = url_overload;
		else {
			if (postTypeId === 3) type = "Article";
			else if (postTypeId === 5) type = "CareerPublished";
			else if (postTypeId === 14) type = "ProAds";
			else if (postTypeId === 4) type = "SmallAds";
			if (isRejected) url = type + "NotifyRefused";
			else {
				if (new Date(publishedDate) > new Date())
					url = type + "NotifyDelay";
				else url = type + "Notify";
				if (linkType === "sites") {
					if (!url_overload && type === "News") url += "Sites";
					data = {
						message: title,
						// Sites untouched in the wizard: the author's site,
						// which the sites picker shows preselected
						listSiteId: linkTo?.length
							? linkTo
							: siteId
							? [siteId]
							: [],
						author: author,
						publicationDate: publishedDate,
						newsId: postId

					};
				} else {
					data = {
						message: title,
						author: author,
						publicationDate: publishedDate,
						newsId: postId
					};
				}
			}
		}
		if (data_overload) data = data_overload;
		let req = this.fetchAuthor()
			.then((resp) => {
				data.author = resp;
				let prom = genRequest("notifications/push/" + url, data, "post");
				return prom;
			})
			.then((resp) => {
				if (url.indexOf("Delay") === -1) return Promise.resolve(resp);
				let notif = {
					oneSignalId: resp.notifId,
					postId: postId,
					// Alerts pass their own body (data_overload) with timeToNotify
					timeToNotify: data.publicationDate ?? data.timeToNotify,
				};
				return this.saveNotif(notif);
			})
			.catch(() => {
				// Notification service unavailable — skip silently
				return Promise.resolve(true);
			});
		return req;
	};

	this.saveNotif = (data) =>
		genRequest("notifications/scheduled", data, "post");

	this.delete = function () {
		if (!postId) return Promise.resolve(true);
		let req = genRequest(
			"posts/" + postId,
			null,
			"delete"
		);
		return req;
	};

	this.lastChanged = () => lastChanged;

	this.validationModeration = function (setNew) {
		if (typeof setNew !== "undefined") validationModeration = setNew;
		return validationModeration;
	};

	this.draft = function (setDraft) {
		if (setDraft !== undefined) draft = setDraft;
		return draft;
	};

	this.isPublished = () => validationModeration && !draft;

	this.postTypeId = () => postTypeId;

	this.linkType = (set_type) => {
		if (set_type && set_type !== linkType) linkType = set_type;
		isTargetPost = linkType === "groups";
		return linkType;
	};

	this.setLinkTo = function (items_list, link_type, default_site_id) {
		if (link_type) this.linkType(link_type);
		if (linkType === "sites") {
			isTargetPost = false;
			if (default_site_id) siteId = default_site_id;
			if (
				!default_site_id &&
				items_list.indexOf(siteId) === -1 &&
				items_list?.length
			)
				siteId = items_list[0];
			linkTo = items_list;
		} else {
			linkTo = items_list;
			isTargetPost = true;
		}
		return linkTo;
	};

	this.getLinksTo = function () {
		if (!(linkType && linkTo)) return false;
		return {
			type: linkType,
			links: linkTo,
		};
	};

	this.linkedTo = () => linkedTo;

	this.title = function (setTitle) {
		if (typeof setTitle !== "undefined") title = setTitle;
		return title;
	};

	this.subTitle = function (setTitle) {
		if (typeof setTitle !== "undefined") subTitle = setTitle;
		return subTitle;
	};

	this.txt = function (setTxt) {
		if (typeof setTxt !== "undefined") txt = setTxt;
		return txt;
	};

	this.mdeRef = function (setRef) {
		if (setRef) MDE_Ref = setRef;
		return MDE_Ref;
	};

	this.images = function (setImages) {
		if (setImages) images = setImages;
		return images;
	};

	this.videos = function (setVideos) {
		if (setVideos) videos = setVideos;
		return videos;
	};

	this.rssImages = function (setImages) {
		if (setImages) rssImages = setImages;
		return rssImages;
	};

	this.removeRssImages = function () {
		rssImages = [];
	};

	this.postId = function (setId) {
		if (typeof setId !== "undefined") postId = setId;
		return postId;
	};

	this.moderationComment = function (setComm) {
		if (typeof setComm !== "undefined") {
			validationModeration = false;
			draft = true;
			moderationComment = setComm;
		}
		return moderationComment;
	};

	this.notification = function (setNotif) {
		if (typeof setNotif !== "undefined") notifyPost = setNotif;
		return notifyPost;
	};

	this.categories = function (setCats) {
		if (typeof setCats !== "undefined") categories = setCats;
		return categories;
	};

	this.documents = function (setDocs) {
		if (typeof setDocs !== "undefined") {
			if (setDocs.length) {
				let res = setDocs.map((a) => {
					let doc = false;
					if (a.typeof) doc = a;
					else doc = new DocumentObject(a);
					let link = this.getLinksTo();
					if (link && doc.isNew())
						doc.setLinkTo(link.links, link.type);
					return doc;
				});
				docs = res;
			} else docs = setDocs;
		}
		return docs;
	};

	this.publishedDate = function (setDate) {
		if (typeof setDate !== "undefined") publishedDate = setDate;
		return publishedDate;
	};

	this.isDiffered = () => new Date() < new Date(publishedDate);

	this.isPriority = () => {
		if (!priorityTo) return false;
		return new Date() < new Date(priorityTo);
	};

	this.priorityTo = function (setDate) {
		if (typeof setDate !== "undefined") priorityTo = setDate;
		return priorityTo;
	};

	this.links = () => {
		if (linkedSites?.length)
			return { type: "sites", links: linkedSites.map((a) => a.siteId) };
		if (linkedGroups?.length)
			return {
				type: "groups",
				links: linkedGroups.map((a) => a.id),
			};
		return { type: "sites", links: [] };
	};

	this.linkedSites = () => linkedSites;

	this.linkedGroups = () => linkedGroups;

	this.linkedForms = (setForms) => {
		if (setForms) linkedForms = setForms;
		return linkedForms;
	};

	this.targets = (values) => {
		if (values) targets = values;
		return targets;
	};

	this.linkTargets = () => {
		if (!targets?.length) return Promise.resolve();
		let items = targets.map((a) => ({
			employeeId: a.employeeId,
			postId,
		}));
		let prom = genRequest("posts/alerts/batch", items, "post");
		return prom;
	};

	this.linkTarget = (employeeId) =>
		genRequest(
			`posts/${postId}/alerts`,
			{ employeeId },
			"post"
		);

	this.sendReponse = () => {
		let that = this;
		if (!response) return Promise.resolve(true);
		if (response && !response.txt()) return this.deleteResponse();
		let prom = new Promise((resolve, reject) => {
			response.send()
				.then(() => {
					return that.linkResponse();
				}, reject)
				.then(resolve, reject);
		});
		return prom;
	};

	this.deleteResponse = () => {
		if (!response) return Promise.resolve(true);
		let prom = new Promise((resolve, reject) => {
			this.unlinkResponse()
				.then(
					() => {
						return response.delete();
					},
					() => response.delete()
				)
				.then(() => {
					response = false;
					resolve(true);
				}, reject);
		});
		return prom;
	};

	this.unlinkResponse = () => {
		if (!response || !response?.postId()) return Promise.resolve(true);
		let req = genRequest(
			"posts/" +
			postId +
			"/news-response/" +
			response.postId(),
			null,
			"delete"
		);
		return req;
	};

	this.linkResponse = () => {
		if (!response || !response?.postId()) return Promise.resolve(true);
		let req = genRequest(
			"posts/" + postId + "/news-response",
			{
				responseId: response.postId(),
			},
			"post"
		);
		return req;
	};

	this.setResponse = (txt, forceEmployeId, forceReset) => {
		let obj = response;
		if (!obj || forceReset)
			obj = new PostObject({
				postTypeId: 2,
				employeeId: forceEmployeId ? forceEmployeId : employeeId,
				siteId,
				title: "Complement d'information",
			});

		obj.txt(txt);
		response = obj;
		return response;
	};

	this.response = () => {
		if (!response) {
			let obj = new PostObject({
				postTypeId: 2,
				employeeId,
				siteId,
				title: "Complement d'information",
				txt: "",
			});
			response = obj;
		}
		return response;
	};

	this.siteId = () => siteId;

	this.employeeId = () => employeeId;

	this.reactionType = (setType) => {
		if (typeof setType !== "undefined") reactionType = setType;
		return reactionType;
	};

	this.values = (with_sub_title) => ({
		postId: postId,
		postTypeId: postTypeId,
		title:
			(with_sub_title && subTitle?.length
				? `${subTitle}/__CUT__\\`
				: "") + title,
		employeeId: employeeId,
		txt: txt,
		siteId: siteId,
		validationModeration: validationModeration,
		draft: draft,
		address: address,
		viewCount: viewCount,
		likesCount: likesCount,
		publishedDate: publishedDate,
		priorityTo: priorityTo,
		moderationComment: moderationComment,
		lastChanged: lastChanged,
		lastChangeAuthorId: lastChangeAuthorId,
		hasDuplicate: hasDuplicate,
		languageId: languageId,
		isTargetPost: isTargetPost,
	});
}
